import React from 'react';
import PropTypes from 'prop-types';
import StudentsDropdown from 'legacy-src/utility/StudentsDropdown';
import StudentResponses from 'legacy/src/components/assessment/Results/shared/StudentResponses';
import StudentResponsesModal from 'legacy/src/components/assessment/Results/StudentResponses/components/StudentResponsesModal';
import { getPartByDomQuestion } from '../components/utils';
import './styles.scss';

/**
 * Draws student responses
 * */
const TeacherContainer = (props) => {
  const {
    assignment: { title, questions },
    submissionData,
    router,
    params,
    onModalClosePath,
    onStudentChangePath,
    usePartsOnChangeEvent,
  } = props;
  const { subject, assignmentId, studentId, questionId, partId } = params;

  if (!submissionData || !submissionData.length) {
    return null;
  }

  const students = submissionData.filter(({ status }) =>
    ['scored', 'student_scored', 'teacher_and_student_scored'].includes(status),
  );

  const onModalClose = () => {
    const pathname =
      onModalClosePath ||
      `/${subject}/assessments/results/${assignmentId}/students/${studentId}/questions/${questionId}`;
    persistLocation(pathname);
  };

  const onChange = (selection) => {
    const { value } = selection;
    const pathname = onStudentChangePath
      ? onStudentChangePath.replace('$STUDENT_ID$', value)
      : `/${subject}/assessments/results/${assignmentId}/students/${value}/responses/questions/${questionId}`;
    persistLocation(pathname);
  };

  const persistLocation = (pathname) => {
    let newPath = pathname;
    if (partId) {
      newPath += `/parts/${partId}`;
    } else {
      const { children = [] } =
        questions.find(({ id }) => questionId === id) || {};
      const currentPart = getPartByDomQuestion(questionId, children);
      if (currentPart && usePartsOnChangeEvent) {
        newPath += `/parts/${currentPart.id}`;
      }
    }
    router.push(newPath);
  };

  const modalHeader = (
    <div className="StudentResponsesModal--header">
      <h3>{title}</h3>
      <StudentsDropdown
        students={students}
        studentId={studentId}
        onChange={onChange}
      />
    </div>
  );

  return (
    <StudentResponsesModal
      modalTitle={title}
      modalHeader={modalHeader}
      onClose={onModalClose}
    >
      <StudentResponses
        {...props}
        studentId={studentId}
        onClose={onModalClose}
      />
    </StudentResponsesModal>
  );
};

TeacherContainer.displayName = 'TeacherContainer';

TeacherContainer.propTypes = {
  assignment: PropTypes.object.isRequired,
  submissionData: PropTypes.array.isRequired,
  onModalClosePath: PropTypes.string,
  onStudentChangePath: PropTypes.string,
  usePartsOnChangeEvent: PropTypes.bool,
};

TeacherContainer.defaultProps = {
  assignment: {},
  onModalClosePath: null,
  onStudentChangePath: null,
  usePartsOnChangeEvent: true,
};

export default TeacherContainer;
